import { render, staticRenderFns } from "./HorseInformation.vue?vue&type=template&id=4e019d12&"
import script from "./HorseInformation.vue?vue&type=script&lang=js&"
export * from "./HorseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports